import { getUserCblcDigit } from "./services/user/user.service";

/**
 * Formata o CBLC do usuário com um '-' antes do último número
 * @param {string} cblc do usuário
 */
export const formatCBLC = (cblc) => {
    if (cblc === undefined || cblc[cblc.length - 2] === '-') return cblc;
    return cblc + '-' + getUserCblcDigit(cblc);
};


/**
 * Mostra alguma funcionalidade de acordo com o CBLC do usuário passado como parâmetro
 * @param {any} user objeto user retornado da store
 * @param {any} userAuth objeto userAuth retornado da store
 * @param {Array<number>} cblcList array de números finais de CBLC para exibirem algum componente para estes CBLCs 
 */
export const showForSelectedCBLC = (user: any, userAuth:any, cblcList: Array<number>): boolean  => {
    if (user === undefined || userAuth === undefined) return false;
    
    return cblcList.some(cblc => {
        return parseInt(userAuth.currentUser.cblc[userAuth.currentUser.cblc.length - 1]) === cblc;
    });
}

/**
 * Valores padrões da página Home do Logged
 */
export const infoHomeLoggedPage = {
    categoryAttendenceLevelUrl: 'https://conteudos.toroinvestimentos.com.br/atendimento-contas',
};
